import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const CineplexDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Cineplex,
  hasCustomUI: false,
  friendlyName: 'Cineplex Displays',
  description: `Defines the properties required for a Cineplex integration.`,
  category: IntegrationCategoryEnum.Displays,
  platforms: [],
  type: IntegrationTypeEnum.ContentTargeting,
  settings: {},
  properties: {},
  mobilePermissions: [],
};

/**
 * @deprecated Use `CineplexDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { CineplexDefinition } from 'application-types';`
 */
export default CineplexDefinition;
